"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Phase4 = Phase4;
require("core-js/modules/es.promise.js");
require("core-js/modules/esnext.iterator.constructor.js");
require("core-js/modules/esnext.iterator.filter.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _react = require("react");
var _greenTick = require("../assets/green-tick.svg");
var _stylesModule = _interopRequireDefault(require("./styles.module.css"));
var _PhaserGame = require("../tutorial-game/PhaserGame");
var _EventBus = require("../tutorial-game/EventBus");
var _ontouchcog = require("../assets/blocks/ontouchcog.svg");
var _onnotouchcog = require("../assets/blocks/onnotouchcog.svg");
var _up = require("../assets/blocks/up.svg");
var _down = require("../assets/blocks/down.svg");
var _nowhere = require("../assets/blocks/nowhere.svg");
var _blockSelector = _interopRequireDefault(require("../block-selector-4"));
var _playbutton = _interopRequireDefault(require("../assets/playbutton.svg"));
var _selectedBlocksFromTutorial = require("../utils/selected-blocks-from-tutorial");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const posterItemsNoClick = [{
  icon: _up.ReactComponent,
  block: "moveup",
  execute: async () => true
}, {
  icon: _nowhere.ReactComponent,
  block: "dontmove",
  execute: async () => true
}, {
  icon: _down.ReactComponent,
  block: "movedown",
  execute: async () => true
}];
const posterItemsClick = [{
  icon: _up.ReactComponent,
  block: "moveup",
  execute: async () => true
}, {
  icon: _nowhere.ReactComponent,
  block: "dontmove",
  execute: async () => true
}, {
  icon: _down.ReactComponent,
  block: "movedown",
  execute: async () => true
}];
const staticBlockItemUp = {
  icon: _ontouchcog.ReactComponent,
  block: "ontouchcog",
  execute: async () => true
};
const staticBlockItemDown = {
  icon: _onnotouchcog.ReactComponent,
  block: "onnotouchcog",
  execute: async () => true
};
function Phase4(_ref) {
  let {
    nextPhase
  } = _ref;
  const [gameContainerDimensions, setGameContainerDimensions] = (0, _react.useState)({
    width: "40vw",
    height: "30vh",
    visibility: "hidden"
  });
  const [posterItemsClickState, setPosterItemsClickState] = (0, _react.useState)([]);
  const [posterItemsNoClickState, setPosterItemsNoClickState] = (0, _react.useState)([]);
  const [tickIconState, setTickIconState] = (0, _react.useState)("hidden");
  const [blocksIconState, setBlocksIconState] = (0, _react.useState)("visible");
  const [showAreYouReady, setShowAreYouReady] = (0, _react.useState)(false);
  const phaserGameRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    // setting a timeinterval to check every 100ms if both controls have been set
    const checkControlsSet = setInterval(() => {
      var _phaserGameRef$curren, _phaserGameRef$curren2;
      const noClickBlock = (_phaserGameRef$curren = phaserGameRef.current) === null || _phaserGameRef$curren === void 0 || (_phaserGameRef$curren = _phaserGameRef$curren.scene) === null || _phaserGameRef$curren === void 0 || (_phaserGameRef$curren = _phaserGameRef$curren.selectedCogNoClickBlock) === null || _phaserGameRef$curren === void 0 ? void 0 : _phaserGameRef$curren.block;
      const clickedBlock = (_phaserGameRef$curren2 = phaserGameRef.current) === null || _phaserGameRef$curren2 === void 0 || (_phaserGameRef$curren2 = _phaserGameRef$curren2.scene) === null || _phaserGameRef$curren2 === void 0 || (_phaserGameRef$curren2 = _phaserGameRef$curren2.selectedCogClickedBlock) === null || _phaserGameRef$curren2 === void 0 ? void 0 : _phaserGameRef$curren2.block;
      if ((noClickBlock === "movedown" || noClickBlock === "moveup") && (clickedBlock === "movedown" || clickedBlock === "moveup")) {
        setShowAreYouReady(true);
        clearInterval(checkControlsSet);
      }
    }, 100);
    return () => {
      clearInterval(checkControlsSet);
    };
  }, []);
  (0, _react.useEffect)(() => {
    // setting the poster items for click and no click IF they exist in the game
    const noClickBlock = _selectedBlocksFromTutorial.selectedBlockFromTutorialForNoClick;
    const clickedBlock = _selectedBlocksFromTutorial.selectedBlockFromTutorialForClick;
    if (clickedBlock) {
      const index = posterItemsClick.findIndex(item => item.block === clickedBlock.block);
      if (index !== -1) {
        const selectedBlock = posterItemsClick[index];
        const middleIndex = Math.floor(posterItemsClick.length / 2);
        // remove the selected block from the poster items
        const newposterItemsClick = posterItemsClick.filter(item => item.block !== selectedBlock.block);
        // add the selected block to the middle of the poster items
        newposterItemsClick.splice(middleIndex, 0, selectedBlock);
        setPosterItemsClickState(newposterItemsClick);
      }
    } else {
      // if the clicked block is not set, we set the poster items to the default ones
      setPosterItemsClickState(posterItemsClick);
    }
    if (noClickBlock) {
      const index = posterItemsNoClick.findIndex(item => item.block === noClickBlock.block);
      if (index !== -1) {
        const selectedBlock = posterItemsNoClick[index];
        const middleIndex = Math.floor(posterItemsNoClick.length / 2);
        // remove the selected block from the poster items
        const newposterItemsNoClick = posterItemsNoClick.filter(item => item.block !== selectedBlock.block);
        // add the selected block to the middle of the poster items
        newposterItemsNoClick.splice(middleIndex, 0, selectedBlock);
        setPosterItemsNoClickState(newposterItemsNoClick);
      }
    } else {
      // if the no click block is not set, we set the poster items to the default ones
      setPosterItemsNoClickState(posterItemsNoClick);
    }
  }, []);
  (0, _react.useEffect)(() => {
    _EventBus.EventBus.on('sky-ready', sky => {
      const skyHeightScaled = sky.height * sky.scaleFactors.height;
      const skyWidthScaled = sky.width * sky.scaleFactors.width;
      setGameContainerDimensions({
        width: skyWidthScaled + "px",
        height: skyHeightScaled + "px",
        visibility: "visible"
      });
    });
    _EventBus.EventBus.on('current-scene-ready', scene => {
      setTimeout(() => {
        var _scene$player, _scene$stars, _scene$stars2, _scene$sky, _scene$stars3, _scene$sky2;
        scene.physics.world.setBounds(0, 0, scene.scale.width, scene.scale.height);
        (_scene$player = scene.player) === null || _scene$player === void 0 || _scene$player.setCollideWorldBounds(true);
        scene.spawnStar();
        scene.spawnStar();
        const star1 = (_scene$stars = scene.stars) === null || _scene$stars === void 0 ? void 0 : _scene$stars.getChildren()[0];
        const star2 = (_scene$stars2 = scene.stars) === null || _scene$stars2 === void 0 ? void 0 : _scene$stars2.getChildren()[1];
        const skyWidthScaled = (_scene$sky = scene.sky) === null || _scene$sky === void 0 ? void 0 : _scene$sky.scaleFactors.width;
        Phaser.Actions.SetX(((_scene$stars3 = scene.stars) === null || _scene$stars3 === void 0 ? void 0 : _scene$stars3.getChildren()) || [], 400 * (skyWidthScaled || 1));
        const skyHeightScaled = (_scene$sky2 = scene.sky) === null || _scene$sky2 === void 0 || (_scene$sky2 = _scene$sky2.scaleFactors) === null || _scene$sky2 === void 0 ? void 0 : _scene$sky2.height;
        if (star1) Phaser.Actions.SetY([star1], 700 * (skyHeightScaled || 1));
        if (star2) Phaser.Actions.SetY([star2], 200 * (skyHeightScaled || 1));
      }, 1000);
    });

    // EventBus.on('star-collected', (scene: PlayScene) => {
    //     if (scene.collectedStars === 2) {
    //         setShowAreYouReady(true);
    //         // setTimeout(() => {
    //         //     setBlocksIconState("animation");
    //         //     phaserGameRef.current?.game?.destroy(true);
    //         // }, 1500);
    //     }
    // });

    return () => {
      _EventBus.EventBus.removeListener('star-collected');
      _EventBus.EventBus.removeListener('sky-ready');
      _EventBus.EventBus.removeListener('current-scene-ready');
      _EventBus.EventBus.removeListener('player-jumped');
    };
  }, []);
  const onBlocksAnimationEnd = (0, _react.useCallback)(() => {
    setBlocksIconState("hidden");
    setTickIconState("animation");
  }, []);
  const onTickIconAnimationEnd = (0, _react.useCallback)(() => {
    nextPhase();
  }, []);
  const blocksIconContainerClasses = [_stylesModule.default.doubleColumnContainer, blocksIconState === "animation" ? _stylesModule.default.fadeOutAnimation : "", blocksIconState === "hidden" ? _stylesModule.default.hide : ""].join(" ");
  const tickIconClassNames = [_stylesModule.default.tickIconFullScreen, tickIconState === "animation" ? _stylesModule.default.fadeInAnimation : "", tickIconState === "hidden" ? _stylesModule.default.hide : "", tickIconState === "visible" ? _stylesModule.default.show : ""].join(" ");
  const handleAreYouReadyClick = () => {
    var _phaserGameRef$curren3;
    // setTimeout(() => {
    setBlocksIconState("animation");
    (_phaserGameRef$curren3 = phaserGameRef.current) === null || _phaserGameRef$curren3 === void 0 || (_phaserGameRef$curren3 = _phaserGameRef$curren3.game) === null || _phaserGameRef$curren3 === void 0 || _phaserGameRef$curren3.destroy(true);
    setShowAreYouReady(false);
    if (phaserGameRef.current && phaserGameRef.current.scene) {
      (0, _selectedBlocksFromTutorial.setSelectedBlockFromTutorialForNoClick)(phaserGameRef.current.scene.selectedCogNoClickBlock);
      (0, _selectedBlocksFromTutorial.setSelectedBlockFromTutorialForClick)(phaserGameRef.current.scene.selectedCogClickedBlock);
    }
    // }, 1500);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: _stylesModule.default.singleColumnContainer,
    children: [showAreYouReady && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _stylesModule.default.areYouReadyContainer,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: _playbutton.default,
        alt: "Play",
        className: _stylesModule.default.playButton,
        onClick: handleAreYouReadyClick
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: blocksIconContainerClasses,
      onAnimationEnd: onBlocksAnimationEnd,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: _stylesModule.default.doubleBlockSelectorContainer,
        children: [!!posterItemsClickState.length && /*#__PURE__*/(0, _jsxRuntime.jsx)(_blockSelector.default, {
          gameRef: phaserGameRef,
          staticBlock: "up",
          posterItems: posterItemsClickState,
          staticBlockItem: staticBlockItemUp
        }), !!posterItemsNoClickState.length && /*#__PURE__*/(0, _jsxRuntime.jsx)(_blockSelector.default, {
          gameRef: phaserGameRef,
          staticBlock: "down",
          posterItems: posterItemsNoClickState,
          staticBlockItem: staticBlockItemDown
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _stylesModule.default.gameContainer,
        style: gameContainerDimensions,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PhaserGame.PhaserGame, {
          ref: phaserGameRef
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_greenTick.ReactComponent, {
      className: tickIconClassNames,
      onAnimationEnd: onTickIconAnimationEnd
    })]
  });
}